import { ComponentStyleConfig } from '@chakra-ui/react';

export const inputStyle: ComponentStyleConfig = {
  parts: ['field'],
  baseStyle: {
    field: {
      outline: 0,
      boxShadow: 0,
      border: 'none',
      borderWidth: 1,
      borderColor: 'red.500',
    },
  },
  sizes: {
    sm: {
      field: {
        borderRadius: 5,
        fontSize: 'sm',
        px: 6,
        h: '40px',
      },
    },
    md: {
      field: {
        fontSize: 'sm',
        px: 5,
        h: '44px',
      },
    },
  },
  variants: {
    unstyled: {
      field: {
        bg: 'transparent',
        _focus: {
          boxShadow: 0,
        },
        _active: {
          boxShadow: 0,
        },
      },
    },
    outline: {
      field: {
        _focus: {
          borderColor: 'primary',
          boxShadow: 0,
        },
        _active: {
          boxShadow: 0,
          borderColor: 'primary',
        },
        _disabled: {
          bg: '#f5f5f5',
          opacity: 0.6,
          cursor: 'default',
        },
        _hover: {},
        _invalid: {
          borderColor: 'red.500',
          borderWidth: 1.4,
        },
      },
      _placeholder: {
        color: 'text.placeholder',
      },
      border: '1px solid',
      borderColor: 'inputBorder',
      addon: {
        borderColor: 'primary',
        boxShadow: 0,
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
};
